import {
  acceptOnlyFilterdKeys,
  arrangeFiltersByOrder,
  basePathRewrite,
  cetgoriesCount,
  commonPropsForSSR,
  decodeTwice,
  ensureVisitorId,
  getAbsoluteURL,
  getEBendPoints,
  getEJendPoints,
  getJobIndex,
  getRmcCategories,
  getSavedSearchIdData,
  getURLSearchParams,
  handeActiveFilter,
  modifyJobFilters,
  modifyQueryLocation,
  modifySelectedLocation,
  readCookie,
} from '@components/common';
import companiesMapping from '@components/common/companiesMapping.json';
import {
  _CONSTANTS,
  ApplyJobStatus,
  US_GLOBAL_LOCATION,
} from '@components/common/constant';
import {
  addJobsCountTraits,
  jobSearchResultTrackEvent,
  jobTableTrackImpressionsEvent,
} from '@components/common/event-tracker';
import {
  getFilterQueryString,
  mapQueryParams,
} from '@components/common/filterHelper';
import { RemoteCategoriesMetaTags } from '@components/metaComponent/remoteCategories';
import SearchListingContainer from '@components/searchListContainer';
import {
  CountryResponseProps,
  IDeviceType,
  IJobCount,
} from '@components/shared.types';
import { JobLinks, socialLinks } from '@components/wlb/constant';
import {
  CategoryDetailsPage,
  JobsList,
  useDeviceType,
  useLandingPageTracking,
} from '@license-admin/boldjobs';
import { fireExperimentEvent } from '@utils/cdnTracking';
import { processJobDetailsForExperiment } from '@utils/showDetails';
import softRegModalProps from '@utils/softRegModalProps';
import { applyJob, getJobDetailsV2, logErrorServer } from 'API/ApiHelpers';
import { jobViewed, modifyJobDetails } from 'API/jobs';
import { apiCallList } from 'API/wlb/ApiClient';
import { blob_image_path, blob_img_path, getENVPath } from 'helper';
import {
  getGuidValue,
  getOrUpdateGUID,
  getSearchType,
} from 'helper/eventTrackingUtils';
import {
  Action,
  ClickOption,
  SearchType,
  TrackingEvents,
  USER_TRAITS_JOBS_COUNT,
  ViewType,
} from 'helper/eventTrackingUtils/constant';
import {
  ConductExperimentV3,
  createCookieServerSide,
  getExperimentVariant,
  getUserExperimentVaient,
} from 'helper/experiments/experimentActions';
import { RMCPortalExperiments } from 'helper/experiments/experimentConstants';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useEffect, useState } from 'react';
const ReactPaginate = dynamic(() => import('react-paginate'), { ssr: false });

interface IProps {
  jobCardData: any;
  themeType?: string;
  selectedLocation?: string;
  searchKeyword?: string;
  selectedCountry?: string;
  queryParams: any;
  isPremiumUser: boolean;
  isLoggedIn: boolean;
  selectedFilters: { [key: string]: Array<string> };
  localization: any;
  deviceType: IDeviceType;
  saveSearchButtonState: string;
  isFromWizardPage: boolean;
  countryList?: CountryResponseProps[];
  config: any;
  hiring_count: IJobCount;
  showAllDropFilters: boolean;
  isSearchScreen?: boolean;
  isSecondaryModalPopup?: boolean;
  userAgent: string;
  isExpSavedSearchVariant?: boolean;
  cookieHeader?: string;
  userInteractionJobId?: string;
  jobs_details_by_id?: any;
  schemaDateModified?: string;
  remoteTypeCount?: any;
}
const Search = (props: IProps) => {
  const {
    themeType,
    selectedLocation,
    searchKeyword,
    saveSearchButtonState,
    queryParams,
    jobCardData,
    localization,
    deviceType,
    config,
    isPremiumUser,
    selectedFilters,
    isLoggedIn,
    isFromWizardPage,
    showAllDropFilters,
    isSecondaryModalPopup,
    cookieHeader,
    userInteractionJobId,
    jobs_details_by_id,
    remoteTypeCount,
  } = props;

  const isMobileView = useDeviceType(deviceType) === 'mobile';
  const router = useRouter();
  const getRmcCategoriesEXPdata = {
    ...jobs_details_by_id,
    getRmcCategories,
  };
  const [jobDetails, setJobDetails] = useState<any>(
    getRmcCategoriesEXPdata || {}
  );
  const [isAddStaticSearchList, setAddStaticSearchList] =
    useState<boolean>(false);
  const [activeJobId, setActiveJobId] = useState<any>(
    userInteractionJobId || null
  );
  const [savedJobsArray, setSavedJobsArray] = useState<number[]>([]);

  const updateSaveJobState = (jobId: number, status: boolean) => {
    if (savedJobsArray.includes(jobId) && status) {
      return;
    }
    setSavedJobsArray((prevState) =>
      !status ? prevState.filter((id) => id !== jobId) : [...prevState, jobId]
    );
  };

  const saveJobState = {
    savedJobsArray,
    updateSaveJobState,
  };

  const queryParamsByOrder = arrangeFiltersByOrder(queryParams);

  const breadCrumbProps = {
    breadCrumbName: `${
      isPremiumUser ? 'rmc-remote-jobs-auth' : 'rmc-remote-jobs-unauth'
    }`,
    breadCrumbNameValue: [''],
    breadCrumbsData: [
      {
        page: 'rmc-remote-jobs-auth',
        title: 'Remote Jobs - No Ads, Scams, or Junk',
        children: [
          {
            name: 'My Dashboard',
            path: basePathRewrite('/dashboard'),
            static: false,
          },
          {
            name: 'Remote Jobs',
            path: basePathRewrite('/remote-jobs'),
            static: false,
          },
          { name: 'Job Listings', path: '', static: true },
        ],
      },
      {
        page: 'rmc-remote-jobs-unauth',
        title: 'Remote Jobs - No Ads, Scams, or Junk',
        children: [
          { name: 'Home', path: basePathRewrite('/'), static: false },
          {
            name: 'Remote Jobs',
            path: basePathRewrite('/remote-jobs'),
            static: false,
          },
          { name: 'Job Listings', path: '', static: true },
        ],
      },
    ],
  };

  // useEffect(() => {
  //   const conductExperiment = async () => {
  //     const visitorId = readCookie(_CONSTANTS.VSTR);
  //     if (visitorId) {
  //       const experimentData = await getBackendVisiterExpDetail(
  //         deviceType,
  //         {
  //           mobile: RMCPortalExperiments.rmcLocationFieldMobile,
  //           desktop: RMCPortalExperiments.rmcLocationFieldDesktop,
  //         },
  //         userAgent
  //       );
  //       if (experimentData?.variant && experimentData?.variant > 2) {
  //         setAddStaticSearchList(true);
  //       }
  //     } else {
  //       setTimeout(conductExperiment, 500);
  //     }
  //   };

  //   const timeoutId = setTimeout(conductExperiment, 500);

  //   return () => clearTimeout(timeoutId);
  // }, []);
  const isDesktopView = useDeviceType(props.deviceType) === 'desktop';

  const [isExpSavedSearchVariant, setSavedSearchDropDownVariant] =
    useState(false);
  const [isExpRemoteTypeVariant, setRemoteTypeUpdate] = useState(false);

  const runExperiment = async () => {
    try {
      let exptData;
      let expUserId;
      let experimentId;

      if (isPremiumUser) {
        let userStatus = readCookie(_CONSTANTS.USER_STATUS);
        const userId = userStatus ? JSON.parse(userStatus)?.User?.UserId : null;
        if (!userId) return;
        const experimentID = isDesktopView
          ? RMCPortalExperiments.rmcSearchDropdownDesktopRC1.id
          : RMCPortalExperiments.rmcSearchDropdownMobileRC1.id;
        const exptData = await getUserExperimentVaient(
          userId,
          experimentID,
          cookieHeader
        );
        if (exptData === 3) {
          setSavedSearchDropDownVariant(true);
        }
      } else {
        const visitorId = await ensureVisitorId(20, 1000);
        if (!visitorId) return;
        experimentId = RMCPortalExperiments.rmcSearchDropdownMobile;
        exptData = await ConductExperimentV3(visitorId, experimentId);

        if (exptData?.data?.variant === 3) {
          setSavedSearchDropDownVariant(true);
        }
      }
    } catch (error) {
      console.error('Experiment conduction error:', error);
    }
  };

  useEffect(() => {
    runExperiment();
  }, [isPremiumUser, isDesktopView, isExpSavedSearchVariant]);

  const [guids, setGuid] = useState<any>(getOrUpdateGUID()); // for event tracking
  const searchForm = (
    <SearchListingContainer
      localization={localization}
      saveSeachButtonState={saveSearchButtonState}
      showAllDropFilters={showAllDropFilters}
      deviceType={deviceType}
      isPremiumUser={isPremiumUser}
      jobsData={jobCardData}
      queryParams={queryParams}
      jobFilters={jobCardData.jobFilters}
      selectedFilters={selectedFilters}
      location={
        selectedLocation || decodeTwice(selectedFilters.joblocations?.[0]) || ''
      }
      searchedJobTitle={searchKeyword}
      isBasealign={isMobileView && isLoggedIn && !props.isPremiumUser}
      isSearchPage={props.isSearchScreen}
      selectedCountry={props.selectedCountry}
      countyList={props.countryList}
      isAddStaticSearchList={isAddStaticSearchList}
      envPath={getENVPath().NEXT_PUBLIC_ROOT_URL}
      themeType={themeType}
      isExpSavedSearchDropDown={isExpSavedSearchVariant}
    />
  );

  const handleApplyJob = () => {
    addJobsCountTraits(USER_TRAITS_JOBS_COUNT.JOB_APPLICATIONS);
    applyJob(activeJobId, ApplyJobStatus.applied);
    trackJobSearchResult(Action.Applied, activeJobId);
  };
  const fetchJobData = async (jobID: string) => {
    if (!jobID) throw new Error('Job ID is required for tracking.');

    const jobDetailResp = await getJobDetailsV2(jobID);
    const jobDetails = jobDetailResp?.data;
    if (!jobDetails) throw new Error(`No job details found for ID: ${jobID}`);

    const jobIndex = getJobIndex(jobCardData.jobs.results, jobID);
    const guid = getGuidValue(setGuid);

    return { jobDetails, jobIndex, guid };
  };
  const determineAccessStatus = (jobDetails: any) => {
    if (isLoggedIn) {
      return isPremiumUser ? SearchType.Unlocked : SearchType.Locked;
    }
    return jobDetails?.isFreeJob ? SearchType.Unlocked : SearchType.Locked;
  };
  const trackJobSearchResult = async (
    action: string,
    jobID?: string,
    clickOption?: string
  ) => {
    const { jobDetails, jobIndex, guid } = await fetchJobData(jobID!);
    const accessStatus = determineAccessStatus(jobDetails);
    const mergerdQueries = {
      ...props?.queryParams,
      ...router.query,
    };
    return jobSearchResultTrackEvent(
      action,
      getSearchType(),
      ViewType.Job_Post_Details,
      accessStatus,
      jobDetails,
      jobCardData,
      mergerdQueries,
      clickOption,
      jobIndex,
      guid
    );
  };

  const trackJobSearchImpression = async (
    action: string,
    jobID?: string,
    clickOption: string | null = null
  ) => {
    const { jobDetails, jobIndex, guid } = await fetchJobData(jobID!);
    const mergerdQueries = {
      ...props?.queryParams,
      ...router.query,
    };
    return jobTableTrackImpressionsEvent(
      action,
      getSearchType(),
      TrackingEvents.Job_Search_Result,
      jobDetails,
      jobCardData,
      mergerdQueries,
      clickOption,
      jobIndex,
      guid
    );
  };

  const showDetails = async (e: any, jobID: string) => {
    if (isMobileView) return;
    try {
      let jobDetailResp = await getJobDetailsV2(jobID);
      jobDetailResp.data = processJobDetailsForExperiment(
        jobDetailResp.data,
        deviceType,
        undefined,
        isPremiumUser
      );
      if (jobDetailResp.data && jobDetailResp.data.company) {
        const companyMapping = companiesMapping.find(
          (company) =>
            company.rmc === jobDetailResp.data.company.slug ||
            company.fj === jobDetailResp.data.company.slug
        );
        if (!companyMapping) {
          jobDetailResp.data.isrmcwpJob = true;
        }
      }
      const getRmcCategoriesData = { getRmcCategories };
      if (isLoggedIn && jobID) {
        addJobsCountTraits(USER_TRAITS_JOBS_COUNT.VIEWED_JOBS);
        jobViewed(jobID);
      }
      setActiveJobId(jobID);
      const enrichedJobDetails = {
        ...jobDetailResp.data,
        ...getRmcCategoriesData,
      };
      setJobDetails(enrichedJobDetails);
    } catch (error) {
      // console.error('Error fetching job details:', error);
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      logErrorServer(
        `FXJ RMC_JOBS Client error: Status Code: ${errorMessage}`,
        `Failed to fetch data from Fuction: showDetails function : ${errorMessage}`,
        true
      );
    }
  };

  const hideDetails = () => {
    setActiveJobId(null);
    setJobDetails({});
  };
  const mergedQueries = {
    ...queryParamsByOrder,
    ...router.query,
    joblocations: selectedLocation,
  };
  const jobsData = {
    ...jobCardData,
    mergedQueries: mergedQueries,
  };
  const getTheRemoteType = () => {
    // Desktop baselined to winning variant (FJ-9903); mobile experiment unchanged.
    if (!isMobileView) {
      setRemoteTypeUpdate(true);
      return;
    }
    try {
      const expVariant = getExperimentVariant(
        RMCPortalExperiments.rmcWizardRemoteTypeUpdateMobile.id,
        cookieHeader
      );
      setRemoteTypeUpdate(expVariant === 3);
    } catch (error) {
      console.error('Visitor experiment conduction error:', error);
    }
  };
  useEffect(() => {
    getTheRemoteType();
  }, [isMobileView, cookieHeader]);
  // Reg modal should show the filtered result count only when the add-education experiment variant is active
  const getEducationExperimentVariant = () => {
    try {
      const expID = isMobileView
        ? RMCPortalExperiments.rmcWizardExperienceEducationMobile.id
        : RMCPortalExperiments.rmcWizardExperienceEducationDesktop.id;

      return getExperimentVariant(expID, cookieHeader) === 3;
    } catch (error) {
      console.error('Visitor experiment conduction error:', error);
      return false;
    }
  };
  const [isEducationExperimentVariant, setIsEducationExperimentVariant] =
    useState(false);
  useEffect(() => {
    setIsEducationExperimentVariant(getEducationExperimentVariant());
  }, [isMobileView, cookieHeader]);
  const hasActiveFilters = Object.keys(selectedFilters || {}).length > 0;
  const filteredHiringCount =
    isEducationExperimentVariant &&
    hasActiveFilters &&
    jobCardData?.jobs?.totalCount != null
      ? { ...props.hiring_count, jobsCount: jobCardData.jobs.totalCount }
      : props.hiring_count;
  const softRegProps = softRegModalProps({
    config,
    jobCardData,
    isFromWizardPage,
    isMobileView: props.deviceType === 'mobile',
    hiring_count: filteredHiringCount,
    isExperiment: isMobileView && !props.isPremiumUser,
    isExpRemoteTypeVariant: isExpRemoteTypeVariant,
    remoteTypeCount: remoteTypeCount,
  });
  // Add this near the other useEffect hooks in your CategoryPage component
  const unlockMobImagePath = `${blob_image_path}unlock-banner-mob.jpg`;
  const unlockImagePath = `${blob_img_path}unlock-banner-2.webp`;

  const BannerProps = {
    breadCrumbProps: breadCrumbProps,
    basePathRewrite: basePathRewrite,
    deviceType: props.deviceType,
    title: 'Remote Jobs',
  };
  useEffect(() => {
    const intervalId = setTimeout(() => {
      // Remove the 'openJobFromCategory' cookie by setting its expiry date to the past
      document.cookie = `openJobFromCategory=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    }, 3000);
    return () => clearTimeout(intervalId);
  }, []);
  useLandingPageTracking();

  return (
    <>
      <Head>
        {RemoteCategoriesMetaTags({
          categoryName: 'search',
          schemaDateModified: props.schemaDateModified,
        })}
      </Head>
      <Script
        src={`${
          getENVPath().NEXT_PUBLIC_ASSET_URL
        }/ui-experimentation/cdn/experiment-sync.min.js`}
        strategy="afterInteractive"
      />
      <Script id="experiment-script" strategy="afterInteractive">
        {`
          window.fireExperimentEvent = ${fireExperimentEvent.toString()};
        `}
      </Script>
      <link
        href={
          !isPremiumUser && isMobileView ? unlockMobImagePath : unlockImagePath
        }
        rel="preload"
        as="image"
        type={!isPremiumUser && isMobileView ? 'image/jpeg' : 'image/webp'}
      />
      <CategoryDetailsPage {...BannerProps} searchForm={searchForm} />

      <JobsList
        isSoftRegModal={!isLoggedIn}
        softRegModalProps={softRegProps}
        breadCrumbProps={breadCrumbProps}
        showDetails={showDetails}
        hideDetails={hideDetails}
        handleApplyJob={handleApplyJob}
        jobDetails={jobDetails}
        jobId={activeJobId}
        isPremiumUser={isPremiumUser}
        isLoggedIn={isLoggedIn}
        deviceType={deviceType}
        themeType={themeType}
        categoryData={jobCardData?.jobs?.results}
        searchedJobTitle={searchKeyword}
        jobLinks={JobLinks}
        socialLinks={socialLinks}
        pageCount={jobCardData?.jobs?.totalPages} //FOR PAGINATION
        localization={localization}
        isSecondaryModalPopup={isSecondaryModalPopup}
        filterProps={{
          type: router?.query?.sortbyposteddate ? 'date' : 'relevance',
          changeFilter: (filterType: ClickOption) => {
            handeActiveFilter(filterType, router);
          },
        }}
        isSearchScreen={props.isSearchScreen}
        isNoSearchResult={jobCardData?.jobs?.resultPerPage < 1}
        saveJobState={saveJobState}
        isBasealign={isMobileView && isLoggedIn && !props.isPremiumUser}
        basePathRewrite={basePathRewrite}
        isSearchPage={props.isSearchScreen}
        trackJobSearchResult={trackJobSearchResult}
        trackJobSearchImpression={trackJobSearchImpression}
        jobCardData={jobsData}
        cetgoriesCount={cetgoriesCount}
        hiring_count={props.hiring_count}
        ReactPaginate={ReactPaginate}
        assetUrl={getAbsoluteURL}
      />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  let { req, res, query } = context;

  res.setHeader(
    'Cache-Control',
    'private, max-age=0, no-cache, no-store, must-revalidate'
  );
  res.setHeader('Vary', 'Cookie, User-Agent');

  let SortByPostedDate = false;
  let jobCardData: any = [];
  let countryList: Array<CountryResponseProps> = [];
  let countryName = '';
  const commonSSRProps = await commonPropsForSSR(req, 'simple-search');
  const { cookieHeader, cookies, isPremiumUser, deviceType, userId } =
    commonSSRProps;

  const parseJobWizardCookie = (cookieValue: string) => {
    if (!cookieValue) return null;
    try {
      return JSON.parse(decodeURIComponent(cookieValue));
    } catch {
      try {
        return JSON.parse(cookieValue);
      } catch {
        return null;
      }
    }
  };

  const jobWizardCookie = parseJobWizardCookie(
    readCookie('job_wizard', cookieHeader) || ''
  );
  const remoteTypeCount = Number(jobWizardCookie?.remote_type_count) || 0;

  // Minimize common props - only include essential ones for SSR
  const minimalCommonProps = {
    isPremiumUser: commonSSRProps.isPremiumUser,
    isLoggedIn: commonSSRProps.isLoggedIn,
    deviceType: commonSSRProps.deviceType,
    userAgent: commonSSRProps.userAgent,
    themeType: commonSSRProps.themeType,
    localization: commonSSRProps.localization,
    config: commonSSRProps.config,
  };
  const previousUrl = req.headers.referer || '/';
  const isFromWizardPage =
    previousUrl?.includes('job_wizard') || previousUrl?.includes('wizard');

  let selectedFilters = acceptOnlyFilterdKeys(query);
  // Wizard redirects pass the single level the user picked separately from the cascaded `educations`
  // filter values (which still drive actual job matching below) so only that one shows as selected here.
  const wizardEducationLevel = query.educationlevel;
  if (wizardEducationLevel && typeof wizardEducationLevel === 'string') {
    selectedFilters = {
      ...selectedFilters,
      educations: [wizardEducationLevel],
    };
  }
  // Not a real backend filter key - drop it so it isn't forwarded to the jobs search API
  delete query.educationlevel;

  query = mapQueryParams(query);
  const queryString: string = getFilterQueryString(query);
  const searchKeyword: string = getURLSearchParams(
    queryString,
    'searchkeyword'
  );
  const isCategoryInUrl: string = getURLSearchParams(queryString, 'categories');
  let selectedLocation: string = getURLSearchParams(query, 'joblocations');
  let pageParam: string = getURLSearchParams(query, 'page');

  // If page parameter exists but is empty, redirect to URL without page parameter
  if (pageParam === '' && context.query.page !== undefined) {
    const { page, ...queryWithoutPage } = context.query;
    const cleanQueryString = new URLSearchParams(
      queryWithoutPage as Record<string, string>
    ).toString();
    return {
      redirect: {
        destination: `/remote-jobs/search${
          cleanQueryString ? `?${cleanQueryString}` : ''
        }`,
        permanent: false,
      },
    };
  }

  // Validate that pageParam is a pure integer string (no letters or special characters)
  const isValidIntegerString = pageParam === '' || /^\d+$/.test(pageParam);
  if (pageParam && !isValidIntegerString) {
    return {
      notFound: true, // This shows the custom 404 page for invalid formats like "1asdasd"
    };
  }

  const pageNumber = pageParam ? parseInt(pageParam, 10) : 1;

  // Initial validation: check for NaN, zero, or negative values
  if (isNaN(pageNumber) || pageNumber < 1) {
    return {
      notFound: true, // This shows the custom 404 page
    };
  }

  if (!searchKeyword || isCategoryInUrl) {
    SortByPostedDate = true;
  }

  const ejEndPoints = getEJendPoints();
  const ebEndPoints = getEBendPoints();

  const apiEndpoints = {
    job_details: {
      ...ejEndPoints.job_details,
      callback: modifyJobFilters,
    },
    hiring_count: ejEndPoints.hiring_count,
    country_list: ebEndPoints.country_list,
  };

  modifyJobDetails(
    apiEndpoints.job_details,
    `search/${queryString.slice(0, -1)}`,
    { SortByPostedDate, jobStatus: true },
    true,
    cookieHeader,
    isFromWizardPage,
    deviceType
  );

  const data = await apiCallList({ apiEndpoints, cookieHeader, req });
  const {
    job_details,
    country_list,
    hiring_count = { jobsCount: 0, companiesCount: 0 },
  } = data;

  // Clean up country list by removing unnecessary fields for bundle size optimization
  countryList =
    country_list?.map((country: any) => {
      delete country.dialingCode;
      delete country.flagIcon;
      return country;
    }) || [];

  let result = apiEndpoints.job_details.callback(
    query,
    job_details,
    isPremiumUser
  );

  query = result.query;
  jobCardData = result.jobCardData;

  // Minimize job data by removing unnecessary fields for SSR bundle size optimization
  if (jobCardData?.jobs?.results) {
    jobCardData.jobs.results = jobCardData.jobs.results.map((job: any) => {
      delete job.accolades;
      delete job.jobCategories;
      delete job.categories;
      delete job.jobBenefits;
      delete job.description;
      delete job.jobSummary;

      // Remove any undefined values by parsing and stringifying
      return JSON.parse(
        JSON.stringify(job, (key, value) => {
          return value === undefined ? null : value;
        })
      );
    });
  }

  // Validate page number against total pages
  const totalPages = jobCardData?.jobs?.totalPages || 1;
  if (pageNumber > totalPages) {
    return {
      notFound: true,
    };
  }

  const { locationObj, isInternationalLocation, locationNameAndState } =
    modifySelectedLocation(selectedLocation, countryList);

  if (selectedLocation) {
    selectedLocation = locationNameAndState;
    countryName = locationObj.countryName;
    query = modifyQueryLocation(locationObj, isInternationalLocation, query);
  }

  const hasLocation =
    locationObj &&
    (locationObj.name ||
      locationObj.cityName ||
      locationObj.stateName ||
      locationObj.countryName);

  // Optimize country list - only include when location filtering is active
  let optimizedCountryList: Array<CountryResponseProps> =
    hasLocation && countryList.length > 0 ? [...countryList] : [];

  optimizedCountryList = optimizedCountryList.filter(
    (elem) => !US_GLOBAL_LOCATION.US_LOC?.includes(elem.countryName)
  );
  // Filter query params to only include essential ones for bundle size optimization
  const essentialQueryParams = [
    'searchkeyword',
    'joblocations',
    'categories',
    'remoteoptions',
    'jobtypes',
    'jobschedules',
    'careerlevel',
    'educations',
    'travels',
    'jobtitles',
    'page',
    'sortbyposteddate',
  ];

  const optimizedQuery = Object.keys(query).reduce((filtered, key) => {
    if (essentialQueryParams.includes(key) && query[key]) {
      filtered[key] = query[key];
    }
    return filtered;
  }, {} as Record<string, any>);

  // Optimize hiring count - only include for premium users or mobile
  const optimizedHiringCount =
    isPremiumUser || deviceType === 'mobile'
      ? hiring_count
      : { jobsCount: 0, companiesCount: 0 };

  // ! This function is to get data for saved search on the basis of saved search id
  // Only fetch when there's actually a saved search in the URL
  const shouldFetchSavedSearch = req.url?.includes('savedsearch=');
  // Parallelize independent async calls to reduce TTFB
  const userInteractionJobIdValue =
    readCookie('openJobFromCategory', cookieHeader) || '';

  const [savedSearchProps, jobByIdResult] = await Promise.all([
    shouldFetchSavedSearch
      ? getSavedSearchIdData(
          req,
          query,
          cookieHeader,
          queryString,
          deviceType,
          selectedFilters
        )
      : Promise.resolve({
          saveSearchButtonState: 'save_search',
          selectedFilters,
          searchKeyword,
        }),
    userInteractionJobIdValue
      ? getJobDetailsV2(userInteractionJobIdValue)
      : Promise.resolve(null),
  ]);

  // Re-process location from saved search data if not already set
  if (
    shouldFetchSavedSearch &&
    savedSearchProps.selectedFilters?.joblocations?.[0] &&
    !selectedLocation
  ) {
    selectedLocation = savedSearchProps.selectedFilters.joblocations[0];
    const {
      locationObj: savedLocObj,
      isInternationalLocation: savedIsIntl,
      locationNameAndState: savedLocNameState,
    } = modifySelectedLocation(selectedLocation, countryList);

    if (selectedLocation) {
      selectedLocation = savedLocNameState;
      countryName = savedLocObj.countryName;
      query = modifyQueryLocation(savedLocObj, savedIsIntl, query);
    }

    const savedHasLocation =
      savedLocObj &&
      (savedLocObj.name ||
        savedLocObj.cityName ||
        savedLocObj.stateName ||
        savedLocObj.countryName);
    if (savedHasLocation && countryList.length > 0) {
      optimizedCountryList = countryList.filter(
        (elem: any) => !US_GLOBAL_LOCATION.US_LOC?.includes(elem.countryName)
      );
    }
  }

  createCookieServerSide(_CONSTANTS.SEARCH_VISITED, 'true', res);
  const userInteractionJobId = userInteractionJobIdValue || null;
  const jobs_details_by_id = jobByIdResult?.data || {};
  const schemaDateModified = new Date().toISOString();

  return {
    props: {
      ...minimalCommonProps, // Use minimized props instead of full commonSSRProps
      ...savedSearchProps,
      jobCardData,
      hiring_count: optimizedHiringCount,
      selectedLocation,
      selectedCountry: countryName || '',
      countryList: optimizedCountryList,
      queryParams: optimizedQuery,
      fullwidth: true,
      isFromWizardPage,
      isSecondaryModalPopup: true,
      showAllDropFilters:
        cookies[_CONSTANTS.SET_SHOW_ALL_DROP_FILTERS] === 'true',
      isSearchScreen: true,
      cookieHeader: commonSSRProps.cookieHeader || '',
      isPremiumUser: isPremiumUser,
      userInteractionJobId,
      jobs_details_by_id: jobs_details_by_id || {},
      schemaDateModified,
      remoteTypeCount: remoteTypeCount,
    },
  };
};

export default Search;
